module.exports = __webpack_public_path__ + "img/ec.b02692e3.svg";